<template>
<div>
    <v-navigation-drawer :clipped="$vuetify.breakpoint.lgAndUp" v-model="drawer" :mini-variant="mini" fixed app permanent width="230" enable-resize-watcher >
        <v-list-item class="userbox">
            <v-list-item-icon>
                <v-icon color="white">mdi-account-circle</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title class=" white--text">{{ this.role}}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>
        <v-list dense nav>
            <v-list-item v-for="item in items" :key="item.text" :to="item.url">
                <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <v-bottom-navigation  absolute horizontal>
           <v-list-item class="logoutbox">
            <v-list-item-icon>
                <v-icon color="maroon">mdi-logout</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
                <v-list-item-title>
                      <v-form @submit.prevent="logout()" ref="form">
                        <v-btn type="submit"><span style="color: color;">Logout</span></v-btn>
                      </v-form> 
                </v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        </v-bottom-navigation>

    </v-navigation-drawer>
</div>
</template>

<script>
import {mapGetters} from "vuex";
import firebase, { messaging } from 'firebase';

export default {
    computed: {
        ...mapGetters(['get_access_token', 'get_user']),
    },
 methods:{

       async logout() { 
                  
                  if(localStorage.getItem('visitor_management_firebase_token')!=null){
                        var token = localStorage.getItem('visitor_management_firebase_token');
                        await this.deleteTokenAsync(token);
                  }
                       
                  localStorage.clear();
                  this.$store.dispatch("removeAccessToken");
                  this.$store.dispatch("removeUser");
                  axios.post(`${process.env.VUE_APP_API_URL}/api/logout`).then((response)=>{
                      if(response.status == 200)
                      {
                       
                        this.$router.replace({name: "login" });
                      }
                    }).catch((error)=>{
                      
                    }).finally(()=>{{
                      
                    }});
                },
            
            async deleteTokenAsync(token) {
                var data={ token };
               
                     axios.post(`${process.env.VUE_APP_API_URL}/api/notification/unsuscribeTokenToTopic`,data)
                    .then((response) => {
                        if (response.data.status == 1) {
                            
                        }  
                  }).catch((error) => {
                    

                  });
                
            }
           },

    mounted() {
        this.role = localStorage.getItem('visitor_management_role');
        if (this.role == "Super Admin" || this.role == "Society Admin") {
            this.items = [{
                    icon: "dashboard",
                    text: "Dashboard",
                    url: '/',
                },
                {
                    icon: "business",
                    text: "Offices",
                    url: '/offices',
                },
                {
                    icon: "edit",
                    text: "Registrations",
                    url: '/registrations',
                },
                {
                    icon: "wc",
                    text: "Visitors",
                    url: '/visitors',
                },
                {
                    icon: "insert_chart",
                    text: "Visits",
                    url: '/visits',
                },
                {
                    icon: "person   ",
                    text: "Vendors",
                    url: '/vendors',
                },
                {
                    icon: "people",
                    text: "Users",
                    url: '/users',
                },
            ];
        } else if (this.role == "Office Admin") {
            this.items = [{
                    icon: "dashboard",
                    text: "Dashboard",
                    url: '/',
                },
                 {
                    icon: "insert_chart",
                    text: "Profile",
                    url: '/profile',
                },
                {
                    icon: "edit",
                    text: "Registrations",
                    url: '/registrations',
                },
                {
                    icon: "wc",
                    text: "Visitors",
                    url: '/visitors',
                },
                {
                    icon: "insert_chart",
                    text: "Visits",
                    url: '/visits',
                },
            ];
        } else {
            this.items = [{
                icon: "dashboard",
                text: "Dashboard",
                url: '/',
            }, ];
        }
    },
    data: () => ({
        list: [],
        padless: false,
        variant: 'fixed',
        user: '',
        logo_width: "100",
        dialog: false,
        role: '',
        drawer: true,
        mini: false,
        search_timer: null,
        default_image_path: "/images/default_user.png",
        bars: [{
                class: ''
            },
            {
                class: '',
                dark: true
            },
            {
                class: 'primary',
                dark: true
            },
            {
                class: 'elevation-0'
            },
        ],
        items: [],
    }),
};
</script>

<style>
.v-navigation-drawer {
    margin-top: 0px !important;
    z-index: 99;
}

.v-toolbar--clipped {
    padding-left: 70px !important;
}

.v-navigation-drawer i.material-icons {
    color: #bbbbc6 !important;
}

.v-navigation-drawer .v-list__tile--active i.material-icons,
.v-navigation-drawer .v-list__tile--active .v-list__tile__title {
    color: #FFFFFF !important;
}

.v-navigation-drawer .v-list__tile--active {
    /* box-shadow: inset 0px 0 3px 0 #ff5252 */
    border-right: 3px solid #FFFFFF;
}

.v-navigation-drawer .v-list__tile__title {
    color: #BBBBC6 !important;
}

.company_logo {
    margin: 20px 0 20px 20px;
}

.v-toolbar {
    box-shadow: none;
}

.v-breadcrumbs {
    padding: 0 !important;
}

.time-pointer {
    cursor: pointer !important;
}

@import './assets/css/style.css';
</style>
